import { http } from '@/utils/http.js';
import { teamPath } from '@/utils/paths.js';

export const EmailAttachmentsApi = {
  getAttachments(id) {
    return http.get(`${teamPath()}/emails/${id}/attachments`).then((response) => response.data.data);
  },
};
